import React, { lazy } from 'react';
import { connect } from 'react-redux';
import qs from 'query-string';
import { FormattedMessage, injectIntl } from 'react-intl';
import LucideIcon from '../lucide-icon';
import Tooltip from 'src/componentes/tooltip';
import {
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Alert as ReactstrapAlert,
} from 'reactstrap';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { Row, Col } from 'src/componentes/grid';
import { autobind } from 'core-decorators';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { CancelToken } from 'axios';

import {
  EXCEPTION_CANCELLATION_TOKEN,
  MAX_EXPORT_LIMIT,
} from 'src/utils/constants';
import httpSelector from 'src/services/httpSelector';
import history from '../../history';
import http from 'src/services/httpService';
import ContentManager from 'src/componentes/content-manager';
import css from 'src/utils/css';
import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import Pagination from 'src/componentes/list/pagination';
import Filtro from 'src/componentes/filtro';
import Table from 'src/componentes/table';
import { Checkbox } from 'src/componentes/Form';
import LoadingContainer from 'src/componentes/loading-container';
import Confirm from 'src/componentes/message-box/confirm';
import ExportLimitMessage from 'src/componentes/export/export-limit-message';
import CriticalConfirm from 'src/componentes/message-box/critical-confirm';
import Alert from 'src/componentes/message-box/alert';
import errorHandler from 'src/utils/error-handler';
import { aplicarValorCampoCustomizadoUrl } from 'src/utils/filtros-url';
import ColunasTabelas from 'src/componentes/list/componentes/colunas-tabela';
import Email from 'src/componentes/email';
import InputSearch from 'src/componentes/input-search';
import { DownloadFile, ParseError } from 'src/services/downloadFileUrl';
import Estatisticas from 'src/paginas/relatorio-acompanhamento/search-estatistica';
import Kanban from 'src/paginas/acao/kanban';
import DialogColunas from 'src/paginas/acao/kanban/components/dialog-colunas';
import FiltroChip from 'src/componentes/filtro-chip';
import guid from 'src/utils/guid';
import { getZIndexAboveDialog } from 'src/utils/zIndexOverlay';
import FiltroDrawerNew from '../filtro/FiltroDrawerNew';
import InfoPanel from 'src/componentes/info-panel';
import applySavedColumnConfig from 'src/componentes/list/utils/apply-saved-column-config';
import {
  MIN_COLUMN_WIDTH,
  buildWidthPayload,
  computeResizedWidth,
  measureHeaderMinWidth,
  withUpdatedColumnWidth,
} from 'src/componentes/list/utils/column-resize';

const GeoreferenciaExibicao = lazy(() =>
  import('src/componentes/list/componentes/georeferencia-exibicao')
);

let classes = css`
  .checkCell {
      width: 40px;
      cursor: pointer;
    }

  .hierarchy {
    width: 15px;
    cursor: pointer;
    margin: -3px 10px;
  }

  .dropdown {
    & > .btn {
      border: 0px;
      color: inherit;
      &:hover {
        background-color: #e4eaec;
        color: inherit;
      }
    }
  }
  .sort {
    position: relative;
    cursor: pointer;
    padding-right: 15px!important;
    &:after{
      font-family: FontAwesome;
      right: 5px;
      font-size: 10px!important;
      position: absolute;
      display: inline-block;
      font-size: inherit;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      margin-top: 3px;
    }
    &:empty{
      &:after{
        display: none;
      }
    }
  }

  .tHeadContent {
    width: -moz-max-content;
    width: -webkit-max-content;
    width: -o-max-content;
    width: -ms-max-content;

    white-space: nowrap;
  }

  .resizeHandle {
    position: absolute;
    top: 0;
    right: 0;
    width: 8px;
    height: 100%;
    cursor: col-resize;
    z-index: 1;
    user-select: none;
    &:hover {
      background-color: rgba(0, 0, 0, 0.12);
    }
  }

  .menulistcustom {
    li a {
      display: block;
      padding: 3px 20px;
      clear: both;
      font-weight: normal;
      line-height: 1.52857;
      color: #5f5f5f;
      white-space: nowrap;
      position: relative;
      .nameFilter{
        display: inline;
      }
      .iconFilter{
        position: absolute;
        right: 5px;
        margin: auto;
      }
    }
  }
`;


@autobind
class List extends React.Component {
  static defaultProps = {
    showMenu: true,
    showEdit: true,
    showDelete: true,
    showNew: true,
    showPage: true,
    showToolBar: true,
    showDetail: false,
    showSearch: false,
    dialogWidth: '70%',
    dialogHeight: '70%',
    labelNew: 'Novo',
    showTitle: false,
    showExport: true,
    showCustomFields: false,
    openLastFilter: true,
    changedColumns: false,
    usarFiltroSalvo: true,
    urlExportItem: null,
    getCorLinha: null,
    showExportItem: false,
    size: 'sm',
    showScrollColumn: true,
    habilitarGeoreferencia: false,
    kanban: false,
    showHierarchyPagination: false,
    showAnaliseCausa: false,
    showFinalRow: false,
    showTotalRow: false,
    refreshOnClose: false,
    autoFocus: true,
    forceSelectedFilter: false,
    colunasDinamicas: [],
    refreshFilterChip: 1,
    usarIdCampCustomizado: false,
    showIconDraggable: false,
    ignoreChipFilterProperties: [],
    permitirSelecionarTodos: false,
    ehSelecaoTotal: false,
  };

  constructor(props) {
    super(props);

    this.dialogRef = React.createRef();
    this.thRefs = {};
    this._resize = null;
    this._justResizedColumn = false;
    this._lastSavedWidths = {};
    this._pendingSave = null;

    this.state = {
      list: this.props.dataSource || [],
      count: 0,
      isLoading: true,
      expandedIds: [],
      selectedIds: [],
      selectedItems: [],
      pageSize: this.props.pageSize || 10,
      currentPage: 1,
      currentItemIndex: -1,
      columns: [],
      allColumns: [],
      columnsComponentOrder: null, //usado para mandar colunas null quando não houver no banco de dados para o component colunas-tabela.jsx
      sort: this.props.sort,
      sortBy:
        this.props.sort &&
        this.props.sort.split(' ')[1] &&
        this.props.sort.split(' ')[1] === 'desc'
          ? 'desc'
          : 'asc',
      searchModelFilter: null,
      selectedFilter: this.props.selectedFilter,
      parameters: this.props.parameters,
      params: this.props.centroCustoId,
      searchModel: null,
      searchEstatistica: null,
      kanbanReady: false,
      kanbanMounted: false,
      kanbanSearchEstatistica: null,
      kanbanParameters: this.props.parameters,
      kanbanFiltrando: true,
      listRequestSignature: null,
      kanbanRequestSignature: null,
      selectAllItems: !!this.props.ehSelecaoTotal,
      ehSelecaoTotal: !!this.props.ehSelecaoTotal,
      excludedIds: Array.isArray(this.props.excludedIds)
        ? this.props.excludedIds
        : [],
      view:
        this.props.kanban && this.props.formatoKanbanDefault
          ? 'kanban'
          : 'lista',
      columnsCard: this.props.columnsCard,
      columnsKanban: this.props.columnsKanban,
      allColumnsCard: this.props.allColumnsCard,
      allColumnsKanban: this.props.allColumnsKanban,
      getCorLinha: this.props.getCorLinha,
      filtrando: true,
      filtrandoBloqueado: false,
      modelValue: null,
      refreshFilterChip: 1,
      componentKey: guid(),
      cancelTokens: {},
      // Estados para o drawer de filtros
      isDrawerMounted: false,
      showFilterDrawer: false,
    };
  }

  componentDidMount() {
    this.props.usandoKanban &&
      this.props.usandoKanban(this.props.formatoKanbanDefault);

    this.obterPageSize();
    this.loadColumns(this.props.children);
    this.loadSelectedIds();
    this.loadPermissions();
    this.renderContent();
  }

  componentWillUnmount() {
    this.listRequestId = (this.listRequestId || 0) + 1;
    Object.keys(this.state.cancelTokens).forEach((key) => {
      this.state.cancelTokens[key] &&
        this.state.cancelTokens[key](EXCEPTION_CANCELLATION_TOKEN);
    });

    if (this._resize) {
      document.removeEventListener('mousemove', this.handleColumnResizeMove);
      document.removeEventListener('mouseup', this.handleColumnResizeEnd);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      this._resize = null;
    }
  }

  createCancelToken(id) {
    const cancelToken = new CancelToken((source) => {
      this.setState((prevState) => ({
        cancelTokens: {
          ...prevState.cancelTokens,
          [id]: source, // armazenar o cancelToken no objeto usando o id como chave
        },
      }));
    });
    return cancelToken;
  }

  loadColumns(children) {
    let childrenArray = children;
    if (!(childrenArray instanceof Array)) {
      childrenArray = [childrenArray];
    }
    var filtered = childrenArray.filter(function (x) {
      return x != null && x != undefined && x != false;
    });

    let allColumns = filtered.map((c) => c.props);

    let columns = [];
    if (this.props.showCustomFields) {
      const customUrl = `/CampoCustomizado/ObterListaCamposCustomizados`;
      httpSelector
        .getHttp(this.props.viewType)
        .post(
          customUrl,
          {
            tipoItem: this.props.tipoItem,
            useCustomFieldId: this.props.usarIdCampCustomizado,
          },
          {
            cancelToken: this.createCancelToken(customUrl),
          }
        )
        .then((response) => {
          let campos = response.data;
          let camposComValorUrl = [];

          if (campos && campos.length > 0) {
            campos.map((itemCC) => {
              let colunaCC = {
                headerText: itemCC.descricaoCampo,
                valueField: itemCC.campo.nome,
                visible: true,
                default: false,
              };
              allColumns.push(colunaCC);
              if (
                this.props?.camposCustomizadosUrl &&
                Object.keys(this.props?.camposCustomizadosUrl).length > 0
              ) {
                const valorUrl =
                  this.props.camposCustomizadosUrl[itemCC.descricaoCampo];
                camposComValorUrl.push(
                  aplicarValorCampoCustomizadoUrl(
                    itemCC,
                    valorUrl,
                    (this.props.camposMultiSelecaoEmConjuntoUrl || []).includes(
                      itemCC.descricaoCampo
                    )
                  )
                );
              }

              return colunaCC;
            });
          }

          if (
            this.props?.camposCustomizadosUrl &&
            Object.keys(this.props?.camposCustomizadosUrl).length > 0
          ) {
            this.setState({
              modelValueCamposCustomizados: camposComValorUrl,
              selectedFilter: {
                ...this.props.modelValue,
                camposCustomizados: camposComValorUrl,
              },
            });

            if (!this.props.usarFiltroSalvo) this.refreshModel();
          }

          this.loadConfigColunasTabela(columns, allColumns);
        });
    } else {
      this.loadConfigColunasTabela(columns, allColumns);
    }
  }

  loadConfigColunasTabela(columns, allColumns) {
    const customUrl = `/ColunasTabela/ObterConfiguracoesColunasTabela`;
    httpSelector
      .getHttp(this.props.viewType)
      .post(
        customUrl,
        {
          tag: this.props.tag || 0,
        },
        {
          cancelToken: this.createCancelToken(customUrl),
        }
      )
      .then((response) => {
        if (this.props.columnsDinamic && this.props.columnsDinamic.length > 0) {
          allColumns = allColumns.concat(this.props.columnsDinamic);
        }

        applySavedColumnConfig(allColumns, columns, response.data);

        if (columns.length === 0) {
          columns = allColumns.filter((c) => c.visible && c.default);
          columns = columns.length === 0 ? allColumns : columns;
        } else {
          const columsRequired = allColumns.filter(
            (c) =>
              c.required &&
              !columns.find((col) => col.valueField === c.valueField)
          );

          if (columsRequired && columsRequired.length > 0)
            columns = columns.concat(columsRequired);
        }

        const columnsComponentOrder = this.props.handleCustomColumnsOrder
          ? this.props.handleCustomColumnsOrder(allColumns, columns)
          : columns;
        this.setState({
          columns: columns,
          allColumns: allColumns,
          columnsComponentOrder: columnsComponentOrder,
        });
      })
      .catch((error) => {
        if (error && error.message === EXCEPTION_CANCELLATION_TOKEN) return;
        errorHandler(error);
      });
  }

  loadSelectedIds() {
    if (this.props.select) {
      this.setState({
        selectedIds:
          this.props.selectedIds && this.props.selectedIds.length > 0
            ? this.props.selectedIds.map((d) => this.getItemKey(d))
            : [],
        //lista de itens
        selectedItems:
          this.props.selectedItems && this.props.selectedItems.length > 0
            ? this.props.selectedItems.map((d) => d)
            : [],
      });
    }
  }

  loadPermissions() {
    if (this.props.ignorePermissions) {
      this.setState(
        {
          permissions: {
            allowView: true,
          },
        },
        () => {
          this.refresh();
        }
      );
      return;
    }

    if (!this.props.local) {
      this.setState({ isLoading: true });

      const customUrl = `${this.props.url}/LoadPermissionsAndSearch`;
      httpSelector
        .getHttp(this.props.viewType)
        .post(
          customUrl,
          {
            parameters: this.props.parameters,
          },
          {
            cancelToken: this.createCancelToken(customUrl),
          }
        )
        .then((response) => {
          this.setState(
            {
              ...response.data,
            },
            () => {
              this.refresh();
            }
          );
        })
        .catch((error) => {
          if (error && error.message === EXCEPTION_CANCELLATION_TOKEN) return;
          errorHandler(error);
        });
    } else {
      this.handleOpenLastFilter(this.refreshModel);
    }
  }

  checkHeaderText(header) {
    if (this.state.columns.headerText !== header) {
      return header;
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.changedColumns !== this.props.changedColumns) {
      this.loadColumns(newProps.children);
    }
    if (newProps.saved !== this.props.saved) {
      this.setState(
        {
          parameters: newProps.parameters,
          ...(this.state.view === 'kanban'
            ? { listRequestSignature: null }
            : { kanbanRequestSignature: null }),
        },
        () => this.refresh()
      );
    } else if (newProps.forceRefresh) {
      this.setState(
        {
          parameters: newProps.parameters,
          ...(this.state.view === 'kanban'
            ? { listRequestSignature: null }
            : { kanbanRequestSignature: null }),
        },
        () => this.refresh()
      );
    }
    if (newProps.dataSource !== this.props.dataSource) {
      this.setState({
        list: newProps.dataSource,
      });
    }
    if (newProps.closeModal) {
      this.handleCloseShowModal();
    }
    if (newProps.selectedFilter !== this.props.selectedFilter) {
      this.setState({ selectedFilter: newProps.selectedFilter });
    }
    if (newProps.columnsCard !== this.props.columnsCard) {
      this.setState({ columnsCard: newProps.columnsCard });
    }
    if (newProps.columnsKanban !== this.props.columnsKanban) {
      this.setState({ columnsKanban: newProps.columnsKanban });
    }
    if (newProps.allColumnsCard !== this.props.allColumnsCard) {
      this.setState({ allColumnsCard: newProps.allColumnsCard });
    }
    if (newProps.allColumnsKanban !== this.props.allColumnsKanban) {
      this.setState({ allColumnsKanban: newProps.allColumnsKanban });
    }
    if (newProps.handleSearch !== this.props.handleSearch) {
      this.refreshModel(newProps.handleSearch);
    }
  }

  handleAtualizarColunas(colunas) {
    this.setState({
      columns: colunas,
      columnsComponentOrder: colunas,
    });
  }

  handleAtualizarCardKanban(colunas) {
    this.setState({
      columnsCard: colunas,
    });
  }

  handleAtualizarColunasKanban(colunas) {
    this.setState({
      columnsKanban: colunas,
    });
  }

  handleSearch(searchModel, atualizarFiltroChip = false) {
    if (this.props.openLastFilter && !this.props.filtroLocal) {
      this.handleOpenLastFilter(this.refreshModel);
    } else {
      this.refreshModel(searchModel);

      let newSearchModel = {};

      if (!searchModel.valor) newSearchModel = { valor: searchModel };
      else newSearchModel = searchModel;

      this.setState({
        selectedFilter: newSearchModel,
        refreshFilterChip: atualizarFiltroChip
          ? this.state.refreshFilterChip + 1
          : this.state.refreshFilterChip,
      });
    }
  }

  handleOpenLastFilter(callback) {
    if (this.props.filtroId && this.props.showSearch) {
      // busca o ultimo filtro acessado
      if (this.props.usarFiltroSalvo && !this.props.modelValue) {
        //se passou o filtro favorito passa o id
        const filtroFavoritoId = window.location.search
          ? qs.parse(window.location.search, { ignoreQueryPrefix: true })
              .filtroFavoritoId || null
          : null;

        httpSelector
          .getHttp(this.props.viewType)
          .post(`/FiltroColaborador/${this.props.filtroId}/AbrirUltimoFiltro`, {
            filtroFavoritoId: filtroFavoritoId,
          })
          .then((response) => {
            if (response.data) {
              this.setState({
                searchModelFilter: response.data.valor,
                selectedFilter: response.data,
              });
              callback(response.data.valor);

              if (this.props.getFiltroFavorito) {
                this.props.getFiltroFavorito(
                  response.data.id,
                  response.data.ehFavorito,
                  response.data.tipoFiltro
                );
              }
            } else {
              callback();
            }
          });
      } else {
        httpSelector
          .getHttp(this.props.viewType)
          .post(
            `/FiltroColaborador/${this.props.filtroId}/ObterFiltroModelVazio`,
            {}
          )
          .then((response) => {
            if (response.data) {
              this.setState({
                searchModelFilter: response.data.valor,
                selectedFilter: response.data,
              });
              callback(response.data.valor);
            } else {
              callback();
            }
          });
      }
    } else {
      callback();
    }
  }

  handleChangeFiltrandoBloqueado() {
    this.setState(
      {
        filtrandoBloqueado: true,
        listRequestSignature: null,
      },
      () => this.refresh()
    );
  }

  refresh() {
    if (
      (this.props.openLastFilter || this.props.filtroId) &&
      !this.props.forceSelectedFilter
    ) {
      this.handleOpenLastFilter(this.refreshModel);
    } else if (this.props.selectedFilter || this.props.modelValue) {
      this.refreshModel(this.props.selectedFilter?.valor);
    }
    if (this.props.refresh) {
      this.props.refresh();
    }
  }

  getRequestSignature(model, parameters) {
    const modelTemp = model && model.valor != null ? model.valor : model || {};

    return JSON.stringify({
      model: modelTemp,
      parameters: parameters || {},
    });
  }

  async refreshModel(searchModel) {
    this.setState({
      isLoading: true,
    });
    this.props.setIsLoading && this.props.setIsLoading(true);

    let { hierarchy, local, customAction } = this.props;

    let listAction = hierarchy === true ? `ListHierarchy` : `List`;

    if (customAction) listAction = customAction;

    if (local) {
      this.searchLocal();
    } else {
      const filterModel = searchModel?.valor ?? searchModel;
      let newSearchModel = { ...filterModel };

      let parameters = this.state.parameters;

      if (this.props.updateParams) {
        if (searchModel) {
          parameters = this.props.updateParams(
            searchModel.valor ? searchModel.valor : searchModel
          );
          this.setState({
            parameters: { ...parameters },
          });
        } else if (this.props.selectedFilter) {
          parameters = this.props.updateParams(
            this.props.selectedFilter.valor
              ? this.props.selectedFilter.valor
              : this.props.selectedFilter
          );
          this.setState({
            parameters: { ...parameters },
          });
        }
      }

      if (
        !Object.keys(newSearchModel).filter((att) => newSearchModel[att])
          .length &&
        this.props.modelValue
      ) {
        newSearchModel = {
          ...(this.props.modelValue.valor ?? this.props.modelValue),
        };
        if (this.state.modelValueCamposCustomizados)
          newSearchModel.camposCustomizados =
            this.state.modelValueCamposCustomizados;
      }

      newSearchModel = {
        ...newSearchModel,
        searchText: this.getSearchText(newSearchModel),
        filtroInterno: this.props.filtroInterno,
      };

      const requestSignature = this.getRequestSignature(
        newSearchModel,
        parameters
      );
      // descarta respostas de buscas anteriores que chegarem depois
      const requestId = (this.listRequestId || 0) + 1;
      this.listRequestId = requestId;

      if (this.props.kanban && this.state.view === 'kanban') {
        this.setState({
          isLoading: false,
          kanbanFiltrando: this.state.filtrandoBloqueado
            ? this.state.kanbanFiltrando
            : !this.state.kanbanFiltrando,
          filtrandoBloqueado: false,
          searchEstatistica: newSearchModel,
          kanbanReady: true,
          kanbanMounted: true,
          kanbanSearchEstatistica: newSearchModel,
          kanbanParameters: parameters,
          kanbanRequestSignature: requestSignature,
        });
        this.props.setIsLoading && this.props.setIsLoading(false);
        return;
      }

      this.setState({
        searchEstatistica: newSearchModel,
        kanbanReady: true,
      });

      const customUrl =
        this.props.customListUrl ||
        (this.props.lookupUrl
          ? `${this.props.lookupUrl}/Search`
          : `${this.props.url}/${listAction}`);
      const listRequest = {
        model: newSearchModel,
        sort: this.state.sort,
        pageSize: this.state.pageSize,
        page: this.state.currentPage - 1,
        parameters: {
          ...parameters,
          ehAtualizarAcoes: this.props.params
            ? this.props.params.ehAtualizarAcoes
            : false,
        },
      };

      await httpSelector
        .getHttp(this.props.viewType)
        .post(
          customUrl,
          this.props.mapListRequest
            ? this.props.mapListRequest(listRequest)
            : this.props.lookupUrl
            ? {
                ...parameters,
                text: newSearchModel.searchText,
                page: listRequest.page,
                pageSize: listRequest.pageSize,
              }
            : listRequest,
          {
            cancelToken: this.createCancelToken(customUrl),
          }
        )
        .then((response) => {
          if (requestId !== this.listRequestId) return;
          const responseList = response.data.list || response.data.List;
          const responseData = {
            ...response.data,
            list: this.props.transformListItem
              ? responseList?.map(this.props.transformListItem)
              : responseList,
            count: response.data.count ?? response.data.Count,
          };

          if (
            this.state.currentPage > 1 &&
            (!responseData?.list || responseData.list.length == 0)
          ) {
            this.setState({ currentPage: this.state.currentPage - 1 });
            this.refresh();
            return;
          }

          const selectAllItems = this.getSelecaoPaginaAtual(responseData.list);

          if (this.props.selectedItems && this.props.selectedItems.length > 0) {
            const distinctIds = [...responseData.list];

            this.setState({
              isLoading: false,
              filtrando: this.state.filtrandoBloqueado
                ? this.state.filtrando
                : !this.state.filtrando,
              filtrandoBloqueado: false,
              ...responseData,
              listRequestSignature: requestSignature,
              list: distinctIds,
              ...(selectAllItems === null ? {} : { selectAllItems }),
            });
          } else {
            this.setState({
              isLoading: false,
              filtrando: this.state.filtrandoBloqueado
                ? this.state.filtrando
                : !this.state.filtrando,
              filtrandoBloqueado: false,
              ...responseData,
              listRequestSignature: requestSignature,
              ...(selectAllItems === null ? {} : { selectAllItems }),
            });
          }
          this.props.setIsLoading && this.props.setIsLoading(false);
        })
        .catch((error) => {
          // exception silenciada
          if (error && error.message === EXCEPTION_CANCELLATION_TOKEN) return;
          if (requestId !== this.listRequestId) return;

          errorHandler(error);
          this.setState({
            isLoading: false,
          });
          this.props.setIsLoading && this.props.setIsLoading(false);
        });
    }
  }

  handleExportClick = (exportType) => {
    let { intl } = this.props;

    if (this.state.count > MAX_EXPORT_LIMIT) {
      ContentManager.addContent(
        <Confirm
          title={intl.formatMessage({
            id: 'tituloExportacaoComLimite',
          })}
          isFunction
          message={() => <ExportLimitMessage />}
          labelConfirm={intl.formatMessage({
            id: 'exportar',
          })}
          handleConfirm={() => this.handleExport(exportType)}
        />
      );
    } else {
      this.handleExport(exportType);
    }
  };

  handleExport(fileExtension) {
    const url = this.props.urlExportList
      ? this.props.urlExportList
      : `${this.props.url}/ExportList`;

    this.setState({
      isLoading: true,
    });

    let newSearchModel = {
      searchText: this.state.textoPesquisa,
      ...(this.props.selectedFilter ? this.props.selectedFilter.valor : {}),
      ...this.state.searchModelFilter,
    };

    if (this.props.modelValue) {
      newSearchModel = {
        searchText: this.state.textoPesquisa,
        ...this.props.modelValue,
      };
    }

    httpSelector
      .getHttp(this.props.viewType)
      .post(
        url,
        {
          model: newSearchModel,
          sort: this.state.sort,
          pageSize: MAX_EXPORT_LIMIT,
          parameters: this.props.parameters,
          fileExtension: fileExtension,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((response) => {
        this.setState({
          isLoading: false,
        });

        DownloadFile(response);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });

        errorHandler(ParseError(error));
      });
  }

  handlePDFClick() {
    this.handleExportClick('pdf');
  }

  handleExcelClick() {
    this.handleExportClick('xlsx');
  }

  handleEmailClick() {
    ContentManager.addContent(
      <Email
        url={this.props.url}
        model={{
          searchText: this.state.textoPesquisa,
          ...this.state.searchModelFilter,
        }}
        sort={this.state.sort}
        parameters={this.props.parameters}
      />
    );
  }

  handleGeoreferenciaClick() {
    ContentManager.addContent(
      <GeoreferenciaExibicao
        filtroId={this.props.filtroId}
        searchModel={{
          searchText: this.state.textoPesquisa,
          ...this.state.searchModelFilter,
        }}
      />
    );
  }

  searchLocal() {
    const { textoPesquisa, searchModelFilter } = this.state;

    this.setState({
      isLoading: false,
      list: this.props.localSearchFilter
        ? this.props.localSearchFilter({ ...searchModelFilter, textoPesquisa })
        : this.props.dataSource,
    });
  }

  handleNewClick(parentId, par) {
    this.handleClosePopover();
    if (this.props.handleNewClick) {
      this.props.handleNewClick();
    } else {
      if (this.props.local) {
        ContentManager.addContent(
          <this.props.editComponent
            paramsFiltro={this.state.searchEstatistica}
            childTitle={this.props.childTitle}
            mode="edit"
            handleClose={this.handleEditCloseLocal}
            parameters={this.props.parameters}
            {...this.props}
          />
        );
      } else if (this.props.editMode && this.props.editMode === 'page') {
        if (parentId) {
          history.push({
            pathname: `${this.props.urlEdit}`,
            search: `?id=${-1}&parentId=${parentId}`,
          });
        } else {
          history.push({
            pathname: `${this.props.urlEdit}`,
            search: `?id=${-1}`,
          });
        }
      } else {
        if (this.props.lookupUrl && this.newDialogOpen) return;

        this.newDialogOpen = true;
        try {
          ContentManager.addContent(
            <this.props.editComponent
              paramsFiltro={this.state.searchEstatistica}
              mode="edit"
              parameters={{
                ...par,
                ...this.props.parameters,
                parentId: parentId,
              }}
              {...this.props}
              handleClose={
                this.props.lookupUrl
                  ? this.handleNewClose
                  : this.props.handleClose || this.handleEditClose
              }
              showSaveClose={
                this.props.lookupUrl ? true : this.props.showSaveClose
              }
              zIndex={
                this.props.lookupUrl
                  ? getZIndexAboveDialog()
                  : this.props.zIndex
              }
            />
          );
        } catch (error) {
          this.newDialogOpen = false;
          throw error;
        }
      }
    }
  }

  handleNewClose(...args) {
    try {
      this.handleEditClose(...args);
    } finally {
      this.newDialogOpen = false;
    }
  }

  handleEditClick(item, index) {
    this.handleClosePopover();
    if (this.props.local) {
      ContentManager.addContent(
        <this.props.editComponent
          childTitle={this.props.childTitle}
          item={item}
          indexItem={index}
          handleClose={this.handleEditCloseLocal}
          parameters={this.props.parameters}
          {...this.props}
        />
      );
    } else if (this.props.editMode && this.props.editMode === 'page') {
      history.push({
        pathname: `${this.props.urlEdit}`,
        search: `?id=${item.id}`,
      });
    } else {
      ContentManager.addContent(
        <this.props.editComponent
          item={item}
          handleClose={this.handleEditClose}
          parameters={this.props.parameters}
          {...this.props}
        />
      );
    }
  }

  handleEditCloseLocal(saved, isNew, item, index) {
    if (saved) {
      this.props.handleSaveItem &&
        this.props.handleSaveItem(saved, isNew, item, index);
      this.props.onEditClose && this.props.onEditClose();
    }
  }

  handleRecursoClick(item) {
    history.push({
      pathname: '/gerenciar/alocacaorecursos',
      search: `?acaoId=${item.id}&acaoDescricao=${item.descricao}`,
    });
  }

  handleEditClose(saved) {
    if (saved || this.props.refreshOnClose) {
      this.refresh();
    } else {
      this.props.onEditClose && this.props.onEditClose();
    }
  }

  handleDeleteClick(item, index) {
    this.handleClosePopover();
    if (this.props.onDeleting) {
      this.props.onDeleting(item);
    } else {
      if (this.props.useDeleteCriticalConfirm) {
        ContentManager.addContent(
          <CriticalConfirm
            title={this.props.intl.formatMessage({
              id: 'excluir',
            })}
            message={
              <FormattedMessage id="label.desejaMesmoExcluirEsseRegistro" />
            }
            handleConfirm={this.handleDeleteClickConfirm.bind(
              this,
              item,
              index
            )}
            labelConfirm={this.props.intl.formatMessage({
              id: 'label.confirmarExclusao',
            })}
          />
        );
      } else {
        ContentManager.addContent(
          <Confirm
            message={
              <FormattedMessage id="label.desejaMesmoExcluirEsseRegistro" />
            }
            handleConfirm={this.handleDeleteClickConfirm.bind(
              this,
              item,
              index
            )}
          />
        );
      }
    }
  }

  handleDeleteClickConfirm(item, index) {
    if (this.props.local) {
      this.props.handleRemove && this.props.handleRemove(item, index);
    } else {
      http
        .post(`${this.props.url}/Remove`, {
          id: item.id,
          parameters: this.props.parameters,
        })
        .then(() => {
          ContentManager.addContent(
            <Alert
              title={<FormattedMessage id="sucesso" />}
              message={
                <FormattedMessage id="label.registroExcluidoComSucesso" />
              }
            />
          );
          this.refresh();
          this.props.onRemove && this.props.onRemove();
        })
        .catch((error) => {
          errorHandler(error);
        });
    }
  }

  handleToggleClick(id) {
    let index = this.state.expandedIds.indexOf(id);
    if (index === -1) {
      this.state.expandedIds.push(id);
    } else {
      this.state.expandedIds.splice(index, 1);
    }

    this.setState({
      expandedIds: this.state.expandedIds,
    });
  }

  handlePopoverClick(id, tag) {
    this.setState({
      currentItemIndex: tag.target.id.toString() === id.toString() ? id : 0,
    });
  }

  handleClosePopover() {
    this.setState({
      currentItemIndex: -1,
    });
  }

  //exportar item do edit
  handleExportItem(item, extensaoExport) {
    if (this.props.urlExportItem) {
      this.setState({
        isLoading: true,
      });
      http
        .post(
          this.props.urlExportItem,
          {
            id: item.id,
            extensaoExport: extensaoExport,
            parameters: this.props.parameters,
          },
          {
            responseType: 'arraybuffer',
          }
        )
        .then((response) => {
          this.setState({
            isLoading: false,
          });

          DownloadFile(response);
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });

          errorHandler(ParseError(error));
        });
    }
  }

  isExpanded(item) {
    return this.state.expandedIds.indexOf(item.id) !== -1;
  }

  getHeaderText(column) {
    if (column.resource) {
      if (this.state.resources) {
        return this.state.resources[column.resource];
      } else {
        return column.headerText;
      }
    } else {
      return column.headerText;
    }
  }

  getCellPopoVer(item, column) {
    if (column.popoverFunction) {
      return column.popoverFunction(item);
    }
  }

  getCellContent(item, column, utilizaColunasDinamicas) {
    if (item.tipoExibicaoWidget == '2') return;

    if (column.valueFunction) {
      return column.valueFunction(item, this.handleEditClose);
    }

    if (column.valueField) {
      let value = item[column.valueField];

      if (utilizaColunasDinamicas && item.valoresColunasDinamicas) {
        const colunaEncontrada = item.valoresColunasDinamicas.find(
          (colunaDinamica) => colunaDinamica.idColuna == column.valueField
        );
        if (colunaEncontrada) value = colunaEncontrada.descricao;
      }

      if (column.formatFunction) {
        value = column.formatFunction(value);
      }

      if (item.campoCustomizado) {
        if (item.campoCustomizado.length > 0) {
          let campoCustomizado = item.campoCustomizado.find((i) =>
            i.valueField
              ? i.valueField == column.valueField
              : i.nomeCampo === column.valueField
          );
          if (campoCustomizado) value = campoCustomizado.valor;
        }
      }

      return value;
    }
  }

  setState(changes, callback) {
    let futureState = {
      ...this.state,
      ...changes,
    };

    let maxPage = Math.floor(futureState.count / futureState.pageSize) + 1;

    if (futureState.currentPage > maxPage) {
      changes.currentPage = maxPage;
    } else if (futureState.currentPage < 1) {
      changes.currentPage = 1;
    }

    super.setState(changes, callback);
  }

  changePageSize(pageSize) {
    this.savePageSize(pageSize);
    this.setState(
      {
        pageSize: pageSize,
      },
      () => {
        this.refresh();
      }
    );
  }

  changeCurrentPage(newValue) {
    this.setState(
      {
        currentPage: newValue,
        selectAllItems:
          !!this.props.permitirSelecionarTodos && !!this.state.ehSelecaoTotal,
      },
      () => {
        this.refresh();
      }
    );
  }

  async obterPageSize() {
    if (this.props.filtroId && this.props.showPage) {
      const customUrl = `/ListagemTelaColaborador/ObterPageSize`;
      await httpSelector
        .getHttp(this.props.viewType)
        .post(
          customUrl,
          {
            listId: this.props.filtroId,
          },
          {
            cancelToken: this.createCancelToken(customUrl),
          }
        )
        .then((response) => {
          if (response?.data) {
            this.setState({
              pageSize: response.data,
            });
          }
        });
    }
  }

  async savePageSize(pageSize) {
    if (this.props.filtroId) {
      await http.post(`/ListagemTelaColaborador/SalvarPageSize`, {
        telaId: this.props.filtroId,
        pageSize: pageSize,
      });
    }
  }

  changeSort(sortField) {
    if (this._justResizedColumn) return;

    let newSortBy = this.state.sortBy === 'asc' ? 'desc' : 'asc';
    let newSortField = newSortBy ? sortField + ' ' + newSortBy : sortField;
    this.setState(
      {
        sort: newSortField,
        sortBy: newSortBy,
      },
      () => {
        this.refresh();
      }
    );
  }

  itemEstaSelecionado(item) {
    return this.state.selectedIds.indexOf(this.getItemKey(item)) !== -1;
  }

  getSelecaoPaginaAtual(list) {
    if (!this.props.permitirSelecionarTodos || this.state.ehSelecaoTotal) {
      return null;
    }

    const { disableSelectedItems } = this.props;
    const selectedIds = this.state.selectedIds || [];
    const selectable = (list || []).filter(
      (item) => !disableSelectedItems || !disableSelectedItems(item)
    );

    return (
      selectable.length > 0 &&
      selectable.every(
        (item) => selectedIds.indexOf(this.getItemKey(item)) !== -1
      )
    );
  }

  getItemKey(item) {
    return this.props.getItemKey ? this.props.getItemKey(item) : item.id;
  }

  handleSelectAllItems(event, items) {
    const isChecked = event.target.checked;
    let selectedItems = [];
    let selectedItemsId = [];
    const { disableSelectedItems } = this.props;
    const itensFiltrados = items.filter(
      (item) =>
        !disableSelectedItems ||
        (disableSelectedItems && !disableSelectedItems(item))
    );

    itensFiltrados.forEach((item) =>
      this.toggleItemMulti(item, selectedItems, selectedItemsId, isChecked)
    );

    const selecionouTodosOsRegistros =
      !!this.props.permitirSelecionarTodos &&
      isChecked &&
      this.state.count > 0 &&
      itensFiltrados.length === this.state.count;

    if (!this.state.selectAllItems)
      this.props.selectIds && this.props.setSelectIds(selectedItemsId);

    this.setState(
      {
        selectAllItems: !this.state.selectAllItems,
        ehSelecaoTotal: selecionouTodosOsRegistros,
        excludedIds: [],
      },
      () => {
        if (this.props.selectRealTime) {
          this.handleConfirmSelection();
        }
      }
    );
  }

  handleAtivarSelecaoTotal() {
    this.setState(
      {
        selectAllItems: true,
        ehSelecaoTotal: true,
        excludedIds: [],
      },
      () => {
        if (this.props.selectRealTime) {
          this.handleConfirmSelection();
        }
      }
    );
  }

  handleLimparSelecao() {
    this.setState(
      {
        selectedIds: [],
        selectedItems: [],
        selectAllItems: false,
        ehSelecaoTotal: false,
        excludedIds: [],
      },
      () => {
        if (this.props.selectRealTime) {
          this.handleConfirmSelection();
        }
      }
    );

    this.props.selectIds && this.props.setSelectIds([]);
    this.props.selectIds && this.props.changeMultipleSelectDataEvent();
  }

  toggleItemMulti(item, selectedItems, selectedItemsId, isChecked) {
    const { disableSelectedItems } = this.props;
    const itemKey = this.getItemKey(item);

    if (disableSelectedItems && disableSelectedItems(item)) return;

    if (!isChecked && this.itemEstaSelecionado(item)) {
      selectedItems = selectedItems.filter(
        (i) => this.getItemKey(i) !== itemKey
      );
      selectedItemsId = selectedItemsId.filter((id) => id !== itemKey);
    } else {
      selectedItems.push(item);
      selectedItemsId.push(itemKey);
    }

    this.setState({
      selectedIds: selectedItemsId,
      selectedItems:
        selectedItems && selectedItems.length > 0
          ? selectedItems.map((item) => item)
          : [],
    });
  }

  toggleItem(item) {
    const { disableSelectedItems } = this.props;
    const itemKey = this.getItemKey(item);
    if (disableSelectedItems && disableSelectedItems(item)) return;

    let selectedIdsTemp = this.state.selectedIds;
    let selectedItemsTemp = this.state.selectedItems.map((item) => item);

    if (!this.props.multiple) {
      selectedIdsTemp = [];
      selectedItemsTemp = [];
    }

    if (this.itemEstaSelecionado(item)) {
      selectedIdsTemp = this.state.selectedIds.filter((id) => id !== itemKey);
      selectedItemsTemp = this.state.selectedItems.filter(
        (i) => this.getItemKey(i) !== itemKey
      );
    } else {
      if (!this.props.multiple) {
        selectedIdsTemp = selectedIdsTemp.concat([itemKey]);
        selectedItemsTemp.push(item);
      } else {
        selectedIdsTemp = this.state.selectedIds.concat([itemKey]);
        selectedItemsTemp.push(item);
      }
    }

    this.setState(
      {
        selectedIds: selectedIdsTemp,
        selectedItems:
          selectedItemsTemp && selectedItemsTemp.length > 0
            ? selectedItemsTemp.map((item) => item)
            : [],
        selectAllItems:
          this.props.permitirSelecionarTodos && this.state.ehSelecaoTotal,
        ehSelecaoTotal:
          this.props.permitirSelecionarTodos && this.state.ehSelecaoTotal,
        excludedIds:
          this.props.permitirSelecionarTodos && this.state.ehSelecaoTotal
            ? this.state.excludedIds.indexOf(itemKey) === -1
              ? this.state.excludedIds.concat([itemKey])
              : this.state.excludedIds.filter((id) => id !== itemKey)
            : [],
      },
      () => {
        if (this.props.selectRealTime) {
          this.handleConfirmSelection();
        }
      }
    );

    this.props.selectIds && this.props.setSelectIds(selectedIdsTemp);
    this.props.selectIds && this.props.changeMultipleSelectDataEvent();
  }

  getSearchText(searchModel) {
    return (
      this.state.textoPesquisa ??
      searchModel?.searchText ??
      searchModel?.valor?.searchText
    );
  }

  getListModel() {
    const searchModel = this.state.searchEstatistica;
    if (!searchModel) return null;

    const model =
      searchModel.valor != null ? { ...searchModel.valor } : { ...searchModel };
    const searchText = this.getSearchText(searchModel);

    if (searchText) model.searchText = searchText;

    return model;
  }

  getSelectionMeta() {
    const selectedItems = this.getAllSelectedItems(this.state.selectedItems);
    const ehSelecaoTotal =
      !!this.props.permitirSelecionarTodos && !!this.state.ehSelecaoTotal;

    return {
      items: selectedItems,
      count: ehSelecaoTotal
        ? Math.max(this.state.count - this.state.excludedIds.length, 0)
        : selectedItems.length,
      model: this.getListModel(),
    };
  }

  handleConfirmSelection() {
    if (this.props.selectedCallback) {
      if (this.props.permitirSelecionarTodos) {
        const selection = this.getSelectionMeta();

        this.props.selectedCallback(selection.items, {
          ehSelecaoTotal: this.state.ehSelecaoTotal,
          count: selection.count,
          excludedIds: this.state.excludedIds,
          model: selection.model,
        });
      } else {
        this.props.selectedCallback(
          this.getAllSelectedItems(this.state.selectedItems)
        );
      }
    }

    if (!this.props.selectRealTime) {
      this.dialogRef.current.close();
    }
  }

  getAllSelectedItems(list, result = []) {
    let { hierarchy } = this.props;

    list.filter((item) => {
      if (this.itemEstaSelecionado(item)) {
        result.push(item);
      }
      if (hierarchy && item.children && item.children.length > 0) {
        this.getAllSelectedItems(item.children, result);
      }
      return null;
    });
    return result;
  }

  handleTextoPesquisaChange(value) {
    if (value)
      this.setState({
        textoPesquisa: value.target ? value.target.value : value,
      });

    clearTimeout(this.textoPesquisaDebounceId);
    this.textoPesquisaDebounceId = setTimeout(() => {
      this.refresh();
    }, 1000);
  }

  handleCustomItemClick(item, customItem) {
    this.handleClosePopover();
    customItem.onClick &&
      customItem.onClick(item, customItem.parameters, this.handleEditClose);
  }

  getVisibleCreateChildItems(listItem, item) {
    return listItem.map((customItem, index) => {
      let visible = customItem.visible(item);
      if (visible) {
        return (
          <DropdownItem
            key={4 + index}
            onClick={this.handleCustomItemClick.bind(this, item, customItem)}
          >
            <LucideIcon icon={customItem.icon} />
            {customItem.label}
          </DropdownItem>
        );
      }
    });
  }

  handleColunasTabelaClick(columns) {
    ContentManager.addContent(
      <ColunasTabelas
        columns={columns}
        allColumns={this.state.allColumns}
        tag={this.props.tag}
        handleAtualizarColunas={this.handleAtualizarColunas}
        isValidDragToUsedColumns={this.props.isValidDragToUsedColumns}
      />
    );
  }

  handleColunasKanbanClick() {
    ContentManager.addContent(
      <DialogColunas
        allColumnsKanban={this.state.allColumnsKanban}
        allColumnsCard={this.state.allColumnsCard}
        columnsKanban={this.state.columnsKanban}
        columnsCard={this.state.columnsCard}
        handleAtualizarCardKanban={this.handleAtualizarCardKanban}
        handleAtualizarColunasKanban={this.handleAtualizarColunasKanban}
      />
    );
  }

  handleSort(id, column) {
    let { sort, sortBy } = this.state;
    if (!sort) return;
    if (column.sortField == sort.split(' ')[0] && sortBy == 'desc') {
      return (
        <LucideIcon
          icon="ChevronUp"
          style={{ cursor: 'pointer' }}
          id={id}
          size={14}
          className="ml-2"
        />
      );
    }

    if (column.sortField == sort.split(' ')[0] && sortBy == 'asc') {
      return (
        <LucideIcon
          icon="ChevronDown"
          style={{ cursor: 'pointer' }}
          id={id}
          size={14}
          className="ml-2"
        />
      );
    }

    if (column.sortField)
      return (
        <LucideIcon
          icon="ArrowUpDown"
          style={{ cursor: 'pointer' }}
          id={id}
          size={14}
          className="ml-2"
        />
      );
  }

  handleCloseShowModal() {
    this.dialogRef.current && this.dialogRef.current.close();
  }

  handleEstatisticas() {
    ContentManager.addContent(
      <Estatisticas
        searchModel={this.state.searchEstatistica}
        parameters={this.state.parameters}
      ></Estatisticas>
    );
  }

  handleViewChange(view) {
    if (view === this.state.view) return;

    const currentRequestSignature = this.getRequestSignature(
      this.state.searchEstatistica,
      this.state.parameters
    );
    const loadedRequestSignature =
      view === 'kanban'
        ? this.state.kanbanRequestSignature
        : this.state.listRequestSignature;
    const shouldRefresh = loadedRequestSignature !== currentRequestSignature;

    this.props.usandoKanban && this.props.usandoKanban(view === 'kanban');
    this.setState(
      {
        view: view,
      },
      () => {
        if (shouldRefresh) this.refresh();
      }
    );
  }

  handleFiltroModal() {
    let {
      searchComponent,
      searchSchema,
      url,
      filtroId,
      showModal,
      usarFiltroSalvo,
      onChangeUrl,
      modelValue,
      tipoItem,
      modalClose,
      filterDrawer,
      ...other
    } = this.props;
    let { selectedFilter, search } = this.state;

    this.setState({
      modelValue: modelValue,
    });

    if (filterDrawer) {
      // Para drawer: abre o drawer inline
      this.handleOpenDrawer();
      return;
    }

    // Para modal: usa o ContentManager (comportamento original) - COMPONENTE ORIGINAL
    ContentManager.addContent(
      <Filtro
        {...other}
        onChangeUrl={onChangeUrl}
        modelValue={modelValue}
        filtroId={filtroId}
        usarFiltroSalvo={usarFiltroSalvo}
        searchComponent={searchComponent}
        searchSchema={searchSchema}
        onSearch={this.handleSearch}
        showModal={showModal}
        url={url}
        selectedFilter={selectedFilter}
        search={search}
        tipoItem={tipoItem}
        modalClose={modalClose}
      />
    );
  }

  render() {
    if (this.props.showModal) {
      let { select } = this.props;
      let actions = select && [
        <Button onClick={this.props.remove} key="btnclose" color="secondary">
          <FormattedMessage id="label.cancelar" />
        </Button>,
        <Button
          key="bynSave"
          type="primary"
          style={{ marginLeft: 10 }}
          onClick={this.handleConfirmSelection}
          disabled={
            this.props.requireSelectionToConfirm &&
            this.state.selectedIds.length === 0
          }
        >
          <FormattedMessage id="label.confirmar" />
        </Button>,
      ];
      return (
        <Dialog
          title={this.props.title}
          customTitle={this.props.customTitle}
          padContent
          width={this.props.dialogWidth}
          height={this.props.dialogHeight}
          onRequestClose={this.handleCloseShowModal}
          mouseDownClose={false}
          ref={this.dialogRef}
          {...this.props}
          actions={
            this.props.actions && this.props.actions.length > 0
              ? this.props.actions
              : actions
          }
        >
          {this.renderContent()}
        </Dialog>
      );
    } else {
      return this.renderContent();
    }
  }

  handleColumnResizeStart(event, column) {
    event.preventDefault();
    event.stopPropagation();

    const th = this.thRefs[column.valueField];
    this._resize = {
      valueField: column.valueField,
      column,
      startX: event.clientX,
      startWidth: th ? th.offsetWidth : parseInt(column.width, 10) || 150,
      minWidth: Math.max(
        MIN_COLUMN_WIDTH,
        Number(column.minWidth) || 0,
        measureHeaderMinWidth(th)
      ),
      currentWidth: null,
      moved: false,
    };

    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', this.handleColumnResizeMove);
    document.addEventListener('mouseup', this.handleColumnResizeEnd);
  }

  handleColumnResizeMove(event) {
    if (!this._resize) return;

    if (Math.abs(event.clientX - this._resize.startX) > 3) this._resize.moved = true;

    const newWidth = computeResizedWidth({
      startWidth: this._resize.startWidth,
      startX: this._resize.startX,
      clientX: event.clientX,
      minWidth: this._resize.minWidth,
    });
    this._resize.currentWidth = newWidth;

    // Preview ao vivo direto no DOM: evita re-renderizar tbody inteiro a cada mousemove.
    const th = this.thRefs[this._resize.valueField];
    if (th) {
      th.style.width = `${newWidth}px`;
      th.style.minWidth = `${newWidth}px`;
      th.style.maxWidth = `${newWidth}px`;
    }
  }

  handleColumnResizeEnd() {
    document.removeEventListener('mousemove', this.handleColumnResizeMove);
    document.removeEventListener('mouseup', this.handleColumnResizeEnd);
    document.body.style.cursor = '';
    document.body.style.userSelect = '';

    const resize = this._resize;
    this._resize = null;
    if (!resize) return;

    if (resize.moved && resize.currentWidth) {
      // O browser ainda despacha um click nativo após o mouseup, geralmente no próprio
      // <th> (não no handle) — esse guard evita que ele dispare changeSort/refresh.
      this._justResizedColumn = true;
      setTimeout(() => {
        this._justResizedColumn = false;
      }, 0);

      this.commitColumnWidth(resize.column, `${resize.currentWidth}px`);
    }
  }

  commitColumnWidth(column, width) {
    const clone = (arr) => withUpdatedColumnWidth(arr, column.valueField, width);

    this.setState(
      (prevState) => ({
        allColumns: clone(prevState.allColumns),
        columns: clone(prevState.columns),
        columnsComponentOrder: prevState.columnsComponentOrder
          ? clone(prevState.columnsComponentOrder)
          : prevState.columnsComponentOrder,
      }),
      () => this.saveColumnWidth(column, width)
    );
  }

  saveColumnWidth(column, width) {
    if (this._lastSavedWidths[column.valueField] === width) return;
    this._lastSavedWidths[column.valueField] = width;

    // Envia todas as colunas exibidas (ver buildWidthPayload): sem isso, um usuário
    // sem configuração salva teria a lista reduzida à coluna redimensionada.
    const displayedColumns =
      this.state.columnsComponentOrder ||
      this.state.columns.filter((x) => x.default);

    const payload = {
      colunasAlteradas: buildWidthPayload(displayedColumns),
      tag: this.props.tag,
    };

    // Encadeia os saves para evitar corrida quando o usuário redimensiona várias
    // colunas em sequência rápida (cada request é um read-modify-write no backend).
    this._pendingSave = (this._pendingSave || Promise.resolve())
      .then(() =>
        httpSelector
          .getHttp(this.props.viewType)
          .post('/ColunasTabela/SalvarTamanhoColunas', payload)
      )
      .catch(errorHandler);
  }

  renderTable(
    count,
    size,
    select,
    multiple,
    showMenu,
    list,
    columns,
    sortDragEnable,
    actionsWidthTemp,
    showHeadTable,
    stickyHeader,
    showIconDraggable
  ) {
    const styleShowHeadTable = !showHeadTable ? 'p-0 border-0' : '';
    const { showTotalRow, colunasDinamicas, utilizaColunasDinamicas } =
      this.props;
    if (utilizaColunasDinamicas && colunasDinamicas) {
      columns = columns.concat(colunasDinamicas);
    }
    // Sem tag as configurações de colunas caem todas no bucket tag=0 no backend,
    // então o resize fica desabilitado para não vazar largura entre telas distintas.
    const columnResizeEnabled = !!this.props.tag && !this.props.disableColumnResize;

    return (
      <Table
        responsive={true}
        count={count}
        size={size}
        stickyHeader={stickyHeader}
        styleDiv={
          this.props.fillAvailableHeight
            ? {
                flex: 1,
                minHeight: 0,
                overflow: 'auto',
                paddingBottom: 15,
              }
            : null
        }
        style={{ background: '#FFF' }}
      >
        {
          <thead className={styleShowHeadTable}>
            <tr>
              {select && !multiple && (
                <td style={{ width: 30 }} className={styleShowHeadTable} />
              )}
              {select && multiple && (
                <Tooltip
                  placement="bottom"
                  disabled={
                    !!this.props.maxSelect ||
                    !this.props.permitirSelecionarTodos
                  }
                  text={this.props.intl.formatMessage(
                    {
                      id: !this.state.selectAllItems
                        ? 'label.selectionarTodosOsxItens'
                        : 'labelDesmarcarTodosXItens',
                    },
                    {
                      x: list ? list.length : 0,
                    }
                  )}
                >
                  <td style={{ width: 30 }} className={styleShowHeadTable}>
                    {!this.props.maxSelect && (
                      <Checkbox
                        id={`CHECK-ALL-${this.state.componentKey}`}
                        checked={this.state.selectAllItems}
                        onChange={(event) =>
                          this.handleSelectAllItems(event, list)
                        }
                        disabled={
                          this.props.maxSelect
                            ? this.state.selectedIds?.length >=
                              this.props.maxSelect
                            : this.props.checkboxDisabled
                            ? this.props.checkboxDisabled
                            : false
                        }
                      />
                    )}
                  </td>
                </Tooltip>
              )}
              {showIconDraggable && (
                <th style={{ width: 30 }} className={styleShowHeadTable} />
              )}
              {showMenu && (
                <th style={{ width: 30 }} className={styleShowHeadTable} />
              )}
              {columns.map(
                (column, index) =>
                  column.visible && (
                    <th
                      ref={(el) => {
                        this.thRefs[column.valueField] = el;
                      }}
                      className={'align-top ' + styleShowHeadTable}
                      key={index}
                      onClick={
                        column.sortField &&
                        this.changeSort.bind(this, column.sortField)
                      }
                      style={{
                        position: 'relative',
                        minWidth: column.widthPersisted
                          ? column.width
                          : column.minWidth
                          ? column.minWidth
                          : 'auto',
                        maxWidth: column.widthPersisted
                          ? column.width
                          : column.maxWidth
                          ? column.maxWidth
                          : 'auto',
                        width: column.width ? column.width : 'auto',
                      }}
                    >
                      {showHeadTable && (
                        <div
                          style={{ margin: column.center && '0 auto' }}
                          className={classes.tHeadContent}
                        >
                          <div className="d-inline">
                            {this.getHeaderText(column)}
                          </div>
                          {column.sortField && (
                            <div className="d-inline">
                              {this.handleSort(index, column)}
                            </div>
                          )}
                        </div>
                      )}
                      {columnResizeEnabled && column.resizable !== false && (
                        <span
                          className={classes.resizeHandle}
                          onMouseDown={(e) =>
                            this.handleColumnResizeStart(e, column)
                          }
                          onClick={(e) => e.stopPropagation()}
                        />
                      )}
                    </th>
                  )
              )}
            </tr>
          </thead>
        }
        <tbody>
          {sortDragEnable
            ? this.renderRowsDroppable(columns, this.state.list)
            : this.renderRows(columns, this.state.list, actionsWidthTemp)}
          {showTotalRow && (
            <tr>{this.renderTotalRow(columns, this.state.list)}</tr>
          )}
        </tbody>
      </Table>
    );
  }

  renderDraggableTable(
    count,
    size,
    select,
    multiple,
    showMenu,
    list,
    columns,
    sortDragEnable,
    actionsWidthTemp,
    showHeadTable,
    stickyHeader,
    showIconDraggable
  ) {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="tableList">
          {(provided) => (
            <div ref={provided.innerRef}>
              {this.renderTable(
                count,
                size,
                select,
                multiple,
                showMenu,
                list,
                columns,
                sortDragEnable,
                actionsWidthTemp,
                showHeadTable,
                stickyHeader,
                showIconDraggable
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleTextoPesquisaChange(this.state.textoPesquisa);
      return;
    }
  };

  handleOpenDrawer = () => {
    this.setState({ isDrawerMounted: true });
    setTimeout(() => {
      this.setState({ showFilterDrawer: true });
    }, 10);
  };

  handleCloseDrawer = () => {
    this.setState({ showFilterDrawer: false });

    setTimeout(() => {
      this.setState({ isDrawerMounted: false });
    }, 300);
  };

  renderInfoPanel = (selectedCount, totalCount) => {
    const { intl } = this.props;
    const isSingular = selectedCount === 1;

    return (
      <InfoPanel showCloseButton={false}>
        <span className="font-weight-bold">
          {`${selectedCount} ${
            isSingular
              ? intl.formatMessage({ id: 'msgAnexoSelecionado' })
              : intl.formatMessage({ id: 'msgAnexosSelecionados' })
          } ${totalCount}.`}
        </span>
      </InfoPanel>
    );
  };

  getCleanedFilterValue(filter) {
    const { ignoreChipFilterProperties } = this.props;

    if (
      !filter ||
      !ignoreChipFilterProperties ||
      ignoreChipFilterProperties.length === 0
    ) {
      return filter && filter.valor != null ? filter.valor : filter;
    }

    if (filter.valor) {
      const cleanedValor = { ...filter.valor };

      ignoreChipFilterProperties.forEach((prop) => {
        delete cleanedValor[prop];
      });

      return cleanedValor;
    }

    const cleaned = { ...filter };
    ignoreChipFilterProperties.forEach((prop) => {
      delete cleaned[prop];
    });

    return cleaned;
  }

  renderSelecaoTotalInfoPanel = () => {
    const totalSelecionado = this.state.ehSelecaoTotal
      ? this.state.count - this.state.excludedIds.length
      : this.state.selectedItems.length;
    const selecionouTodosOsRegistros =
      this.state.count > 0 && totalSelecionado === this.state.count;

    return (
      <ReactstrapAlert
        color="light"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#F0FBFD',
          marginTop: '0.75rem',
          marginBottom: '-1rem',
        }}
      >
        <div className="d-flex align-items-center gap-1">
          {this.state.selectAllItems &&
            !this.state.ehSelecaoTotal &&
            !selecionouTodosOsRegistros && (
              <>
                <span style={{ color: '#71717A' }}>
                  {this.props.intl.formatMessage(
                    { id: 'labelXRegistrosNestaPaginaSelecionados' },
                    {
                      x: (
                        <span style={{ fontWeight: 'bold', color: 'black' }}>
                          {this.state.selectedItems.length}
                        </span>
                      ),
                    }
                  )}
                </span>
                <span
                  style={{
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    color: '#0D7E94',
                  }}
                  onClick={this.handleAtivarSelecaoTotal}
                >
                  {this.props.intl.formatMessage(
                    { id: 'labelSelecionarTodosXRegistros' },
                    { x: this.state.count }
                  )}
                </span>
              </>
            )}

          {(this.state.ehSelecaoTotal || selecionouTodosOsRegistros) && (
            <>
              <span style={{ color: '#71717A' }}>
                {this.props.intl.formatMessage(
                  { id: 'labelXRegistrosSelecionados' },
                  {
                    x: (
                      <span style={{ fontWeight: 'bold', color: 'black' }}>
                        {totalSelecionado}
                      </span>
                    ),
                  }
                )}
              </span>
              <span
                style={{
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  color: '#0D7E94',
                }}
                onClick={this.handleLimparSelecao}
              >
                {this.props.intl.formatMessage({
                  id: 'labelLimparSelecao',
                })}
              </span>
            </>
          )}
        </div>
      </ReactstrapAlert>
    );
  };

  renderContent() {
    let columns = this.state.columnsComponentOrder
      ? this.state.columnsComponentOrder
      : this.state.columns.filter((x) => x.default);

    let pageCount = Math.ceil(this.state.count / this.state.pageSize);

    let {
      select,
      hierarchy,
      actionsWidth,
      showNew,
      showPage,
      showToolBar,
      showSearch,
      showMenu,
      local,
      actions,
      tag,
      showExport,
      intl,
      actionsLocal,
      actionsLocalEnd,
      size,
      modelValue,
      multiple,
      kanban,
      hideSearchText,
      showRemoveEmail,
      searchSchema,
      searchComponent,
      showTitle,
      title,
      handleSendEmails,
      emailsTooltip,
      showAnaliseCausa,
      handleShowAnaliseCausa,
      sortDragEnable,
      actionsToolBar,
      actionsToolBarEnd,
      autoFocus,
      CustomComponent,
      showCustomComponent,
      requiredCustomComponent,
      hideFiltroChip,
      renderNewButton,
      newButtonTestId,
      showHeadTable = true,
      stickyHeader = false,
      showRequired = false,
      hideSendEmail = false,
      showIconDraggable,
      ehReuniao,
      ehParticipantes,
      ehAcao,
      onChangeUrl,
      filtroId,
      usarFiltroSalvo,
      showModal,
      url,
      tipoItem,
      showInfoPanel,
      showConfirmButton,
    } = this.props;

    let { list, selectedFilter, view, search, selectedItems } = this.state;
    let actionsWidthTemp = actionsWidth ? actionsWidth : hierarchy ? 120 : 80;
    let count = local ? (list ? list.length : 0) : this.state.count;

    if (this.props.bloquearMultiplosRegistros && count > 0) {
      showNew = false;
    }

    const allowView =
      Boolean(this.props.lookupUrl) ||
      this.props.ignorePermissions ||
      (this.state.permissions && this.state.permissions.allowView);
    showExport = showExport && allowView;
    const showPagination = allowView;
    const showColumnsButton = !this.props.hideColumnsButton && allowView;
    showSearch = showSearch && allowView;

    return (
      <LoadingContainer
        className={classes.LoadingContainer}
        isLoading={
          this.props.isLoading ||
          (!this.state.filtrandoBloqueado && this.state.isLoading)
        }
        style={
          this.props.fillAvailableHeight
            ? {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                minHeight: 0,
              }
            : undefined
        }
      >
        <Card
          style={
            showRequired
              ? {
                  ...this.props.styleCard,
                  ...(this.props.fillAvailableHeight
                    ? {
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        minHeight: 0,
                      }
                    : {}),
                  borderColor: 'red',
                }
              : this.props.fillAvailableHeight
              ? {
                  ...this.props.styleCard,
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'column',
                  minHeight: 0,
                }
              : this.props.styleCard
          }
        >
          {showToolBar && (
            <CardHeader style={this.props.styleCardHeader}>
              {showTitle && <h5>{title}</h5>}
              <div className="align-items-center d-flex justify-content-between">
                {showSearch && !hideSearchText ? (
                  <div
                    style={{ width: 187, minWidth: 187 }}
                    className="d-inline-flex"
                  >
                    <InputSearch
                      placeholder={intl.formatMessage({
                        id: 'label.pesquisaRapida',
                      })}
                      onKeyPress={this.handleKeyPress}
                      autoFocus={autoFocus}
                      value={this.state.textoPesquisa}
                      onChange={this.handleTextoPesquisaChange}
                      disabled={
                        !this.state.filtrandoBloqueado && this.state.isLoading
                      }
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                {!hideFiltroChip &&
                ((selectedFilter && selectedFilter.valor) ||
                  selectedFilter ||
                  modelValue) ? (
                  <div style={{ minWidth: 40 }} className="mr-auto">
                    <FiltroChip
                      {...this.props}
                      refreshFilterChip={
                        this.props.refreshFilterChip +
                        this.state.refreshFilterChip
                      }
                      updateProps={true}
                      modelValue={modelValue}
                      filtroId={this.props.filtroId}
                      onSearch={this.handleSearch}
                      searchSchema={searchSchema}
                      selectedFilter={this.getCleanedFilterValue(
                        selectedFilter
                      )}
                      currentFilter={selectedFilter}
                      onRemoveFilterChip={this.props.onRemoveFilterChip}
                      onRemoveSaveFilter={this.props.onRemoveSaveFilter}
                      preventRemoveFilterChip={
                        this.props.preventRemoveFilterChip
                      }
                      onChangeUrl={this.props.onChangeUrl}
                    />
                  </div>
                ) : (
                  !showCustomComponent && <div />
                )}

                <div className="d-inline-flex">
                  {showCustomComponent && (
                    <Col>
                      <CustomComponent
                        {...this.props}
                        model={this.props.modelOrigem}
                        disabled={this.props.disabledCustom}
                        required={requiredCustomComponent}
                        selectedItems={this.state.selectedItems || []}
                      />
                    </Col>
                  )}

                  {showRemoveEmail && (
                    <Tooltip
                      placement="bottom"
                      text={intl.formatMessage({
                        id: 'excluirTentativasFracassadas',
                      })}
                    >
                      <Button
                        outline
                        className="tw:ms-2"
                        color={'danger'}
                        toolbar
                        icon="Trash2"
                        onClick={() => {
                          this.props.removeFracassados &&
                            this.props.removeFracassados();
                        }}
                      />
                    </Tooltip>
                  )}
                  {kanban && (
                    <ButtonGroup>
                      {['lista', 'kanban'].map((value) => {
                        let label = ''; //definindo label dos botões
                        if (value === 'lista')
                          label = intl.formatMessage({ id: 'label.lista' });
                        else if (value === 'kanban')
                          label = this.props.resources.kanban;
                        return (
                          <Button
                            color={view === value ? 'primary' : 'secondary'}
                            key={value}
                            eventkey={value}
                            onClick={() => this.handleViewChange(value)}
                          >
                            {label}
                          </Button>
                        );
                      })}
                    </ButtonGroup>
                  )}
                  {handleSendEmails && (
                    <div className="ml-2 d-inline">
                      <Tooltip
                        placement="bottom"
                        text={intl.formatMessage({ id: emailsTooltip })}
                      >
                        <Button
                          toolbar
                          icon="Mail"
                          onClick={handleSendEmails}
                        />
                      </Tooltip>
                    </div>
                  )}
                  {showAnaliseCausa && (
                    <Button
                      className="tw:ms-2"
                      id="showAnaliseCausa"
                      toolbar
                      icon="Lightbulb"
                      onClick={handleShowAnaliseCausa}
                    />
                  )}
                  {showSearch && searchComponent && (
                    <Button
                      className="tw:ms-2"
                      toolbar
                      icon="Filter"
                      onClick={this.handleFiltroModal}
                    />
                  )}
                  {actionsToolBar &&
                    this.state.permissions &&
                    this.state.permissions.allowCreate &&
                    actionsToolBar.map((a, index) =>
                      React.cloneElement(a, {
                        key: index + 4,
                      })
                    )}
                  {(showExport ||
                    (actions && actions.length > 0) ||
                    (Array.isArray(actionsLocal) && actionsLocal.length > 0) ||
                    (Array.isArray(actionsLocalEnd) &&
                      actionsLocalEnd.length > 0)) && (
                    <UncontrolledDropdown
                      group
                      direction="left"
                      className="ml-2 d-inline"
                      key="list"
                    >
                      <DropdownToggle
                        toolbar
                        icon="Ellipsis"
                        className="valores-step5"
                      />
                      <DropdownMenu>
                        {actions &&
                          this.state.permissions &&
                          this.state.permissions.allowCreate &&
                          actions.map((a, index) =>
                            React.cloneElement(a, {
                              key: index + 4,
                            })
                          )}
                        {actionsLocal &&
                          actionsLocal.map((a, index) =>
                            React.cloneElement(a, {
                              key: index + 4,
                            })
                          )}
                        {showExport && actions && actions.length > 0 && (
                          <DropdownItem divider />
                        )}
                        {showExport && !hideSendEmail && (
                          <DropdownItem onClick={this.handleEmailClick}>
                            <FormattedMessage id="enviarEmail" />
                          </DropdownItem>
                        )}
                        {showExport && (
                          <DropdownItem onClick={this.handlePDFClick}>
                            <FormattedMessage id="label.exportarPDF" />
                          </DropdownItem>
                        )}
                        {showExport && (
                          <DropdownItem onClick={this.handleExcelClick}>
                            <FormattedMessage id="label.exportarExcel" />
                          </DropdownItem>
                        )}
                        {(this.props.filtroId === 1 ||
                          this.props.filtroId === 3 ||
                          this.props.filtroId === 4) && (
                          <DropdownItem onClick={this.handleGeoreferenciaClick}>
                            <FormattedMessage id="label.georeferencia" />
                          </DropdownItem>
                        )}
                        {this.props.showEstatistica && (
                          <DropdownItem onClick={this.handleEstatisticas}>
                            <FormattedMessage id="estatisticas" />
                          </DropdownItem>
                        )}
                        {this.props.showArquivamento && (
                          <DropdownItem
                            onClick={() =>
                              history.push('/ferramentas/arquivar-acoes')
                            }
                          >
                            {intl.formatMessage(
                              { id: 'arquivarEmLote' },
                              { acoes: this.props.resources.acoes }
                            )}
                          </DropdownItem>
                        )}
                        {actionsLocalEnd &&
                          actionsLocalEnd.map((a, index) =>
                            React.cloneElement(a, {
                              key: a.key ?? `actionsLocalEnd-${index}`,
                            })
                          )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}
                  {tag && showColumnsButton && (
                    <Button
                      className="tw:ms-2 valores-step2"
                      color="secondary"
                      toolbar
                      icon="Columns3"
                      onClick={
                        view === 'kanban'
                          ? () => this.handleColunasKanbanClick()
                          : this.handleColunasTabelaClick.bind(
                              this,
                              this.state.columnsComponentOrder
                            )
                      }
                    />
                  )}
                  {!this.props.bloquearInsercaoManual &&
                    ((showNew &&
                      this.state.permissions &&
                      this.state.permissions.allowCreate) ||
                      (showNew && local)) &&
                    (renderNewButton ? (
                      <div className="ml-2">
                        {renderNewButton(this.handleNewClick)}
                      </div>
                    ) : (
                      <Button
                        data-testid={newButtonTestId}
                        className={`tw:ms-2 ${
                          ehReuniao
                            ? 'reuniao-step1'
                            : ehParticipantes
                            ? 'reuniao-step4'
                            : ehAcao
                            ? 'acao-step1'
                            : ''
                        }`}
                        toolbar
                        icon="Plus"
                        onClick={this.handleNewClick.bind(this, null, null)}
                      />
                    ))}
                  {actionsToolBarEnd &&
                    actionsToolBarEnd.map((a, index) =>
                      React.cloneElement(a, {
                        key: index + 100,
                      })
                    )}
                </div>
              </div>
              {selectedItems.length > 0 &&
                showInfoPanel &&
                this.renderInfoPanel(selectedItems.length, count)}

              {this.props.permitirSelecionarTodos &&
                !this.state.isLoading &&
                (this.state.selectAllItems || this.state.ehSelecaoTotal) &&
                this.renderSelecaoTotalInfoPanel()}
            </CardHeader>
          )}
          <CardBody
            style={
              this.props.fillAvailableHeight
                ? {
                    ...this.props.styleCardBody,
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    minHeight: 0,
                    overflow: 'hidden',
                  }
                : this.props.styleCardBody
            }
          >
            <Row
              style={
                this.props.fillAvailableHeight
                  ? { flex: 1, minHeight: 0, overflow: 'auto' }
                  : undefined
              }
            >
              <Col
                md={12}
                style={
                  this.props.fillAvailableHeight
                    ? {
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        minHeight: 0,
                      }
                    : undefined
                }
              >
                <>
                  {this.state.kanbanMounted &&
                    this.state.kanbanReady &&
                    (allowView || local) && (
                      <div
                        style={{
                          display: view === 'kanban' ? 'block' : 'none',
                          height: '100%',
                        }}
                      >
                        <Kanban
                          filtrandoBloqueado={this.state.filtrandoBloqueado}
                          handleChangeFiltrandoBloqueado={
                            this.handleChangeFiltrandoBloqueado
                          }
                          exportApresentacao={this.props.exportApresentacao}
                          columnsCard={this.state.columnsCard}
                          columnsKanban={this.state.columnsKanban}
                          handleDescricaoClick={this.props.handleDescricaoClick}
                          filtrando={this.state.kanbanFiltrando}
                          model={
                            this.state.kanbanSearchEstatistica &&
                            this.state.kanbanSearchEstatistica.valor
                              ? this.state.kanbanSearchEstatistica.valor
                              : this.state.kanbanSearchEstatistica
                          }
                          parameters={this.state.kanbanParameters}
                        />
                      </div>
                    )}
                  {view === 'kanban' &&
                    !(allowView || local) &&
                    !this.state.isLoading && (
                      <p>
                        <FormattedMessage id="label.voceNaoTemPermissaoParaVisualizarEstesRegistros" />
                      </p>
                    )}
                  {view === 'lista' &&
                    (this.state.list && this.state.list.length > 0 ? (
                      <div
                        style={
                          this.props.fillAvailableHeight
                            ? {
                                display: 'flex',
                                flex: 1,
                                flexDirection: 'column',
                                minHeight: 0,
                              }
                            : undefined
                        }
                      >
                        <Row
                          style={
                            this.props.fillAvailableHeight
                              ? { flex: 1, minHeight: 0 }
                              : undefined
                          }
                        >
                          <Col
                            style={
                              this.props.fillAvailableHeight
                                ? {
                                    display: 'flex',
                                    flex: 1,
                                    flexDirection: 'column',
                                    minHeight: 0,
                                    overflow: 'auto',
                                  }
                                : undefined
                            }
                            md={12}
                          >
                            {allowView || local ? (
                              sortDragEnable ? (
                                this.renderDraggableTable(
                                  count,
                                  size,
                                  select,
                                  multiple,
                                  showMenu,
                                  list,
                                  columns,
                                  sortDragEnable,
                                  actionsWidthTemp,
                                  showHeadTable,
                                  stickyHeader,
                                  showIconDraggable
                                )
                              ) : (
                                this.renderTable(
                                  count,
                                  size,
                                  select,
                                  multiple,
                                  showMenu,
                                  list,
                                  columns,
                                  sortDragEnable,
                                  actionsWidthTemp,
                                  showHeadTable,
                                  stickyHeader,
                                  showIconDraggable
                                )
                              )
                            ) : (
                              <p>
                                <FormattedMessage id="label.voceNaoTemPermissaoParaVisualizarEstesRegistros" />
                              </p>
                            )}
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <p style={{ fontStyle: 'italic', padding: 20 }}>
                        <FormattedMessage id="label.nenhumRegistroFoiEncontrado" />
                      </p>
                    ))}
                </>
              </Col>
            </Row>
            {view != 'kanban' && (
              <div>
                {this.props.showHierarchyPagination ||
                (!hierarchy && showPage && pageCount && showPagination) ? (
                  <Row>
                    <Col md={12}>
                      <div className="pull-right">
                        <Pagination
                          allowPaging={
                            this.props.showHierarchyPagination ||
                            !this.props.hierarchy
                          }
                          onRefreshClick={this.refresh}
                          currentPage={this.state.currentPage}
                          count={this.state.count}
                          pageSize={this.state.pageSize}
                          showPaginacaoSimples={this.props.showPaginacaoSimples}
                          changeCurrentPage={this.changeCurrentPage}
                          changePageSize={this.changePageSize}
                          noLimitPageSize={this.props.noLimitPageSize}
                          disablePageSizeChange={
                            this.props.disablePageSizeChange
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}
              </div>
            )}
            {this.props.filterDrawer && this.state.isDrawerMounted && (
              <FiltroDrawerNew
                onChangeUrl={onChangeUrl}
                modelValue={modelValue}
                filtroId={filtroId}
                usarFiltroSalvo={usarFiltroSalvo}
                searchComponent={searchComponent}
                searchSchema={searchSchema}
                onSearch={this.handleSearch}
                showModal={showModal}
                url={url}
                selectedFilter={selectedFilter}
                search={search}
                tipoItem={tipoItem}
                tipoLayout="drawer"
                isOpen={this.state.showFilterDrawer}
                handleClose={this.handleCloseDrawer}
                enableSearch={this.props.enableSearch}
                zIndex={this.props.filterDrawerZIndex}
              />
            )}
          </CardBody>
        </Card>
        {showConfirmButton && (
          <Row className="mt-2">
            <Col md={12} className="text-right">
              <Button
                key="bynSave"
                color="primary"
                onClick={this.handleConfirmSelection}
                disabled={
                  this.props.requireSelectionToConfirm &&
                  this.state.selectedIds.length === 0
                }
              >
                <FormattedMessage id="label.confirmar" />
              </Button>
            </Col>
          </Row>
        )}
      </LoadingContainer>
    );
  }

  renderMenu(item, indexItem) {
    let {
      hierarchy,
      createChildItems,
      showEdit,
      showDelete,
      renderMenu,
      showExportItem,
      renderMenuAddOptions,
      ehAcao,
      showRecurso,
    } = this.props;

    if (renderMenu && !renderMenuAddOptions) {
      return this.props.renderMenu(item);
    } else {
      return (
        <UncontrolledDropdown>
          <DropdownToggle
            color="default"
            size="sm"
            toolbar
            icon="EllipsisVertical"
          />
          <DropdownMenu>
            {item.permissions && showEdit && (
              <DropdownItem
                onClick={this.handleEditClick.bind(this, item, indexItem)}
              >
                {this.props.editContainer ?? (
                  <>
                    <LucideIcon icon="Pencil" />
                    <FormattedMessage
                      id="label.editar"
                      values={{ editar: this.props.resources.editar }}
                    />
                  </>
                )}
              </DropdownItem>
            )}
            {createChildItems &&
              item.permissions &&
              item.permissions.allowEdit &&
              this.getVisibleCreateChildItems(createChildItems, item)}
            {showRecurso &&
              ehAcao &&
              item.item &&
              item.item.tipo &&
              item.item.tipo.id == 4 &&
              item.permissions &&
              item.permissions.allowViewAlocacaoRecursos && (
                <DropdownItem
                  onClick={this.handleRecursoClick.bind(this, item)}
                >
                  {this.props.editContainer ?? (
                    <>
                      <LucideIcon icon="Folder" />
                      <FormattedMessage id="recursos" />
                    </>
                  )}
                </DropdownItem>
              )}
            {hierarchy && !createChildItems && (
              <DropdownItem
                onClick={this.handleNewClick.bind(this, item.id, null)}
              >
                <LucideIcon icon="Plus" />
                <FormattedMessage id="label.inserir" />
              </DropdownItem>
            )}
            {item.permissions && item.permissions.allowDelete && showDelete && (
              <DropdownItem
                onClick={this.handleDeleteClick.bind(this, item, indexItem)}
              >
                <LucideIcon icon="Trash2" />
                <FormattedMessage id="excluir" />
              </DropdownItem>
            )}
            {showExportItem && (
              <>
                <DropdownItem
                  onClick={this.handleExportItem.bind(this, item, 'pdf')}
                >
                  <LucideIcon icon="FileText" />
                  <FormattedMessage id="label.exportarPDF" />
                </DropdownItem>
                <DropdownItem
                  onClick={this.handleExportItem.bind(this, item, 'xlsx')}
                >
                  <LucideIcon icon="FileSpreadsheet" />
                  <FormattedMessage id="label.exportarExcel" />
                </DropdownItem>
              </>
            )}
            {renderMenuAddOptions &&
              renderMenu &&
              renderMenu(item, this.props.parameters)}
          </DropdownMenu>
        </UncontrolledDropdown>
      );
    }
  }

  renderFinalRow(item) {
    let { renderFinalRow, iconFinalRow } = this.props;

    if (renderFinalRow) {
      return this.props.renderFinalRow(item);
    } else {
      return <div>{iconFinalRow}</div>;
    }
  }

  renderTotalRow(columns, items) {
    const { renderTotalRow } = this.props;

    if (renderTotalRow) return renderTotalRow(columns, items);
  }

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    this.props.changeOrderList(result.source.index, result.destination.index);
  }

  renderRowsDroppable(columns, items) {
    let { select, showMenu, showFinalRow, showIconDraggable } = this.props;
    const { selectAllItems } = this.state;

    return items.map((item, indexItem) => (
      <Draggable
        index={indexItem}
        key={indexItem + ''}
        draggableId={indexItem + ''}
      >
        {(provided) => (
          <tr
            key={this.getItemKey(item)}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{ ...provided.draggableProps.style }}
          >
            {select && (
              <Tooltip
                placement="bottom"
                text={this.props.messageSelectDisable}
                disabled={
                  !(
                    this.props.maxSelect &&
                    this.state.selectedIds?.length >= this.props.maxSelect &&
                    !this.itemEstaSelecionado(item)
                  )
                }
              >
                <td>
                  <Checkbox
                    id="draggable-checkbox"
                    checked={
                      this.props.permitirSelecionarTodos &&
                      this.state.ehSelecaoTotal
                        ? this.state.excludedIds.indexOf(
                            this.getItemKey(item)
                          ) === -1
                        : selectAllItems
                        ? selectAllItems
                        : this.itemEstaSelecionado(item)
                    }
                    onChange={this.toggleItem.bind(this, item)}
                    disabled={
                      this.props.maxSelect
                        ? this.state.selectedIds?.length >=
                            this.props.maxSelect &&
                          !this.itemEstaSelecionado(item)
                        : this.props.checkboxDisabled
                        ? this.props.checkboxDisabled
                        : false
                    }
                  />
                </td>
              </Tooltip>
            )}
            {showIconDraggable && (
              <td className="fixed-column fixed-row">
                <LucideIcon icon="GripVertical" size={22} />
              </td>
            )}
            {showMenu && (
              <td className="fixed-column fixed-row">
                {this.renderMenu(item, indexItem)}
              </td>
            )}
            {columns.map(
              (column, index) =>
                column.visible && (
                  <td
                    key={index}
                    style={{ verticalAlign: column.verticalAlign }}
                  >
                    <div
                      id={'col' + column.valueField + item.id}
                      style={{
                        textAlign: column.center ? 'center' : 'left',
                        minWidth: '40px',
                        maxHeight: 100,
                        verticalAlign: 'middle',
                        paddingLeft: 0,
                        wordBreak: column.wordBreak ? 'break-word' : null,
                      }}
                    >
                      {this.getCellContent(item, column, false)}
                      {this.getCellPopoVer(item, column)}
                    </div>
                  </td>
                )
            )}
            {showFinalRow && (
              <td style={{ width: '10px' }}>
                {this.renderFinalRow(item, indexItem)}
              </td>
            )}
          </tr>
        )}
      </Draggable>
    ));
  }

  renderRows(columns, items, actionsWidth, level = 0) {
    let {
      select,
      hierarchy,
      showMenu,
      showScrollColumn,
      showFinalRow,
      disableSelectedItems,
      hintOnDisabledItem,
      utilizaColunasDinamicas,
    } = this.props;
    const { selectAllItems } = this.state;
    const colorIcon = '#939393';

    return (
      items &&
      items.map((item, indexItem) => [
        <tr key={this.getItemKey(item)}>
          {select && (
            <Tooltip
              placement="right"
              text={
                this.props.messageSelectDisable &&
                this.props.maxSelect &&
                this.state.selectedIds?.length >= this.props.maxSelect &&
                !this.itemEstaSelecionado(item)
                  ? this.props.messageSelectDisable
                  : disableSelectedItems &&
                    disableSelectedItems(item) &&
                    hintOnDisabledItem
                  ? hintOnDisabledItem(item)
                  : undefined
              }
            >
              <td>
                <Checkbox
                  id={`ROW-CHECK-${this.getItemKey(item)}-${
                    this.state.componentKey
                  }`}
                  checked={
                    this.props.permitirSelecionarTodos &&
                    this.state.ehSelecaoTotal
                      ? this.state.excludedIds.indexOf(
                          this.getItemKey(item)
                        ) === -1 &&
                        (!disableSelectedItems || !disableSelectedItems(item))
                      : selectAllItems
                      ? selectAllItems &&
                        (!disableSelectedItems || !disableSelectedItems(item))
                      : this.itemEstaSelecionado(item)
                  }
                  onChange={this.toggleItem.bind(this, item)}
                  disabled={
                    (disableSelectedItems && disableSelectedItems(item)) ||
                    (this.props.maxSelect
                      ? this.state.selectedIds?.length >=
                          this.props.maxSelect &&
                        !this.itemEstaSelecionado(item)
                      : this.props.checkboxDisabled
                      ? this.props.checkboxDisabled
                      : false)
                  }
                />
              </td>
            </Tooltip>
          )}
          {showMenu && <td>{this.renderMenu(item, indexItem)}</td>}
          {columns.map(
            (column, index) =>
              column.visible && (
                <td key={index}>
                  <div
                    id={'col' + column.valueField + item.id}
                    style={{
                      color: this.props.getCorLinha
                        ? this.props.getCorLinha(item)
                        : '',
                      textAlign: column.center ? 'center' : 'left',
                      minWidth: column.minWidth ? column.minWidth : 40,
                      maxHeight: column.maxHeight ?? 100,
                      minHeight: column.minHeight ?? 0,
                      overflowY: showScrollColumn ? 'auto' : 'visible',
                      verticalAlign: 'middle',
                      paddingLeft: column.tree ? level * 20 : 0,
                      wordBreak: column.wordBreak ? 'break-word' : null,
                    }}
                  >
                    {column.tree &&
                      ((!!(
                        hierarchy &&
                        item.children &&
                        item.children.length
                      ) && (
                        <>
                          {this.isExpanded(item) ? (
                            <LucideIcon
                              icon="ChevronDown"
                              className={classes.hierarchy}
                              color={colorIcon}
                              onClick={this.handleToggleClick.bind(
                                this,
                                item.id
                              )}
                            />
                          ) : (
                            <LucideIcon
                              icon="ChevronRight"
                              className={classes.hierarchy}
                              color={colorIcon}
                              onClick={this.handleToggleClick.bind(
                                this,
                                item.id
                              )}
                            />
                          )}
                        </>
                      )) || (
                        <span
                          className={classes.hierarchy}
                          style={{ display: 'inline-block' }}
                        />
                      ))}
                    {this.getCellContent(item, column, utilizaColunasDinamicas)}
                    {this.getCellPopoVer(item, column)}
                  </div>
                </td>
              )
          )}
          {showFinalRow && (
            <td style={{ width: '10px' }}>
              {this.renderFinalRow(item, indexItem)}
            </td>
          )}
        </tr>,
        this.state.expandedIds.indexOf(item.id) !== -1 &&
          this.renderRows(columns, item.children, actionsWidth, level + 1),
      ])
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    viewType: state.viewType,
  };
}
export default injectIntl(connect(mapStateToProps)(List));
